import {BreakpointObserver} from '@angular/cdk/layout';
import {Component, OnInit} from '@angular/core';
import {ResponsiveMode} from '../../../models/responsive-mode.type';
import {SassHelperComponent} from '../../../providers/sass-helper/sass-helper.component';
import {AuthFacade} from "../../../../auth/facade/auth.facade";
import {SupporterContactInfoModel} from "../../../../auth/models/supporter-contact-info.model";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'morva-ip-error',
  templateUrl: './ip-error.component.html',
  styleUrls: ['./../error.scss'],
})
export class IpErrorComponent implements OnInit {
  responsiveMode: ResponsiveMode;
  supporterContactInfo: SupporterContactInfoModel = {contactInfoType:'' ,email: '', phoneNumber: ''};
  userIp = ''
  private sassHelper: SassHelperComponent;

  constructor(private breakPointObserver: BreakpointObserver, private authFacade: AuthFacade,
              private activatedRoute: ActivatedRoute) {
    this.sassHelper = new SassHelperComponent();
    this.activatedRoute.queryParams.subscribe(params => {
      this.userIp = params['ip'];
    });
  }

  ngOnInit(): void {
    this.breakPointObserver.observe([this.sassHelper.mdMaxWidth]).subscribe(state => {
      if (state.breakpoints[this.sassHelper.mdMaxWidth]) {
        this.responsiveMode = 'md';
      } else {
        this.responsiveMode = 'lg';
      }
    });
    this.getSupporterContactInfo();
  }

  private getSupporterContactInfo() {
    this.authFacade.getSupporterContactInfo().subscribe(res => {
      this.supporterContactInfo = res;
    });
  }

}
